import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectSettingsPage } from '@/features/projects/project-settings-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Réglages d'un projet (porting README #27) : définition et suppression. Rejoints depuis la vue d'ensemble. */
export const Route = createFileRoute('/$tenant/projects/$projectId/settings')({
  component: ProjectSettingsRoute,
});

function ProjectSettingsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="overview"
      crumbs={[{ label: t('projectSettings.short') }]}
    >
      <ProjectSettingsPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
